<template>
<div>
    <button @click="openModal()" class="btn btn-default btn-lg"><icon name="folder-open"></icon> Select tutorial</button>
    <modal title="Select tutorial" large v-model="showModal">
        <div slot="modal-body" class="modal-body">
           
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div v-if="tutorials" v-for="section in tutorials">
                            <h4><icon :name="section.icon" /> {{ section.name }}</h4>
                            <radio v-for="tutorial in section.tutorials"  v-model="selected" :selected-value="tutorial" type="success">{{ tutorial }}</radio>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div v-if="!selected"><h4>Just pick a tutorial from the list on the left...</h4></div>
                        <div v-if="selected">
                            <tutorialDetails :name="selected" :helper="helper" ref="tutorialDetails"></tutorialDetails>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="modal-footer">
            <button type="button" class="btn btn-default btn-lg" @click="showModal = false">Close</button>
            <button type="button" class="btn btn-success btn-lg" @click="loadTutorial()">Start tutorial</button>
        </div>
    </modal>
    <div v-if="!session">
        <transition name="fade">
            <img v-if="showStartHere" src="../../assets/starthere.png">
        </transition>
    </div>
    <div v-if="session">
        <h4 class="page-header">{{ session.tutorial.definition.name }}</h4>
        <resourceTemplate v-if="session.tutorial.definition.guide" :resource="session.tutorial.resources[session.tutorial.definition.guide]"></resourceTemplate>
    </div>
</div>
</template>

<script>

import TutorialPickerHelper from './tutorialPickerHelper'
import tutorialDetails from './TutorialDetails'
import packageLoader from './packageLoader'
import Session from 'runtime/session.js';
import resourceTemplate from '../utils/ResourceTemplate';
import proxy from 'components/console/consoleProxy.js';
import mmProxy from 'components/utils/modalMessage/modalMessageProxy.js';

export default {
  name: 'tutorialPicker',
  data () {
    return {
        showModal: false,
        tutorials: [],
        selected: null,
        session: null,
        showStartHere: false
    }
  },
  mounted() {
    this.helper = new TutorialPickerHelper();
    window.setTimeout(() => {
        this.showStartHere = true;
    }, 5000);
  },
  components: {
      tutorialDetails,
      resourceTemplate
  },
  props: ["workbenchWrapper"],
  methods: {
      openModal() {
        var self = this;
        this.showModal = true;
        // self.workbenchWrapper.getWorkbench().setSession(null);
        this.helper.loadInstalledTutorials(function(tutorials) {
            self.tutorials = tutorials;
            if (!self.selected) {
                self.selected = tutorials[0].tutorials[0];
            }
        });
      },
      loadTutorial() {
        // Tutorial options
        let options;
        try {
            options = this.$refs.tutorialDetails.getOptions();
        } catch (e) {
            this.error("Error getting options for tutorial " + this.selected, e);
            return;
        }
        let self = this;
        if (options) {
            // Close modal
            this.showModal = false;
            let callback = function(tutorial) {
                // initialize IDE
                let config;
                try {
                    config = tutorial.getConfig(options);
                } catch (e) {
                    self.error("Error getting config for tutorial " + self.selected, e);  
                    return;
                }
                try {
                    self.session = new Session(tutorial, config);
                } catch (e) {
                    self.error("Error creating session for tutorial " + self.selected, e);  
                    return;
                }
                self.workbenchWrapper.getWorkbench().setSession(self.session);
            }
            try {
                packageLoader.load(this.selected, callback);
            } catch (e) {
                self.error("Error loading tutorial " + self.selected, e);  
                return;
            }
        }
      },
      error(message, exception) {
        console.error(message, exception);
        mmProxy.errorAlert(message, "Tutorial initialization error");
        proxy.error("System", message);
      }
  },
  watch: {
  }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
        animation: bounce-in .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0;
        animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }

</style>


// WEBPACK FOOTER //
// TutorialPicker.vue?6f490787